import axios from "axios";
import { API_BASE_URL } from "./constants";

function getAccessToken() {
  let userData = JSON.parse(sessionStorage.getItem("userData"));
  if (userData) {
    return userData.access_token;
  } else {
    return "";
  }
}

function getUser() {
  let userData = JSON.parse(sessionStorage.getItem("userData"));
  if (userData) {
    return userData.customer_id;
  } else return;
}

const API_CONFIG = {
  baseURL: `${API_BASE_URL}`,
  headers: {
    "content-type": "application/json; charset=UTF-8"
  },
  transformRequest: [
    function(data, headers) {
      headers.post["Content-Type"] = "application/json; charset=UTF-8";
      headers.post["Authorization"] = "Bearer " + getAccessToken();
      if (data) {
        data["campaign_id"] = 1;
        data["customer_id"] = getUser();
      }
      return JSON.stringify(data);
    }
  ]
};

const API = new axios.create(API_CONFIG);

export default API;



// WEBPACK FOOTER //
// ./src/API.js